import React from "react";
import styled from "styled-components";
import { useSize } from "@lkf/hooks";
import KPI, { IProps as KPIProps } from "./kpi";
import { IProps as SparklineProps } from "./sparkline";
import Trends from "./trends";

export type IProps = KPIProps & SparklineProps;

const BREAKPOINTS = {
  horizontal: 350,
  vertical: 300,
};

const Root = styled.div<{ isSmall: boolean }>`
  height: 100%;
  flex-direction: ${({ isSmall }) => (isSmall ? "row" : "column")};
  align-items: ${({ isSmall }) => isSmall && "stretch"};
  display: ${({ isSmall }) => (isSmall ? "flex" : "block")};
`;

const Metric = styled(KPI)<{ isSmall: boolean; isNarrow: boolean }>`
  flex: 0 0 ${(props) => (props.isNarrow ? 164 : 230)}px;
  padding: ${(props) => (props.isSmall ? 0 : 72)}px 24px
    ${(props) => (props.isSmall ? 0 : 48)}px 0;
  align-self: ${(props) => (props.isSmall ? "flex-end" : "flex-start")};
  position: relative;
  bottom: -10px;
`;

const MetricTrend = ({
  count,
  evolution,
  locale,
  data,
  onClick,
  className,
  evolutionTooltip,
  color,
  isPercentage = false,
  disableAnimation = false,
  isFullscreen,
}: IProps) => {
  const ref = React.useRef();
  const { width, height } = useSize(ref);
  const isNarrow = width < BREAKPOINTS.horizontal;
  const isSmall = isFullscreen || height < BREAKPOINTS.vertical;
  const displayLine = width > 200;
  return (
    <Root ref={ref} className={className} isSmall={isSmall}>
      <Metric
        count={count}
        evolution={evolution}
        locale={locale}
        isNarrow={isNarrow}
        isSmall={isSmall}
        onClick={onClick}
        evolutionTooltip={evolutionTooltip}
        isPercentage={isPercentage}
        disableAnimation={disableAnimation}
      />
      {!!data && displayLine && (
        <Trends
          isSmall={isSmall}
          data={data}
          color={color}
          polarizeColors={isPercentage}
          disableAnimation={disableAnimation}
        />
      )}
    </Root>
  );
};

export default MetricTrend;
